import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "../../../Common/SecondaryButton";

interface OverrideQuestionnaireModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const OverrideQuestionnaireModal = ({ isOpen, onClose, onConfirm }: OverrideQuestionnaireModalProps) => {
    const handleConfirm = () => {
        onConfirm();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Override Global Questionnaire</Modal.Header>

            <Modal.Body>
                <div className="space-y-4">
                    <p className="text-gray-700">
                        This product is using the Global Questionnaire. To use the Ask Each Attendee option for an
                        add-on, you&apos;ll need a product-level questionnaire.
                    </p>
                    <p className="font-medium">Would you like Xola to do this for you?</p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="flex justify-end gap-3">
                    <SecondaryButton onClick={handleCancel}>Cancel</SecondaryButton>
                    <SubmitButton onClick={handleConfirm}>Confirm</SubmitButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
